let loading: Promise<void> | null = null;

export function loadGoogleMapsPlaces(): Promise<void> {
  if (typeof window === 'undefined')
    return Promise.reject(new Error('no window'));
  if ((window as any).google?.maps?.places) return Promise.resolve();

  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const key = import.meta.env.VITE_GOOGLE_MAPS_KEY as string | undefined;
      if (!key) return reject(new Error('Missing VITE_GOOGLE_MAPS_KEY'));

      const s = document.createElement('script');
      s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
        key
      )}&libraries=places`;
      s.async = true;
      s.defer = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('Failed to load Google Maps JS'));
      document.head.appendChild(s);
    });
  }

  return loading;
}
